import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@/auth/useCurrentUser';

/**
 * Which business you are working in (M0-24).
 *
 * ⚠️ Deliberately a **stub**, per the story. It is not a switcher yet, and it
 * cannot be: one Entra identity resolves to exactly one application user and
 * therefore one account — that uniqueness is the tenant routing key (M0-21).
 * Real switching needs a person to hold several user records and a way to
 * choose between them at sign-in, which is a decision nobody has made.
 *
 * It earns its place now by putting the account name on screen: multi-account
 * bugs are much easier to spot when the tenant is visible, and the shell should
 * not have to be rebuilt around it later.
 */
export function AccountSwitcher() {
  const { t } = useTranslation();
  const { data: me, isPending } = useCurrentUser();

  if (isPending) {
    return (
      <div className="h-9 animate-pulse rounded-md bg-[var(--color-muted)]" aria-hidden="true" />
    );
  }

  if (!me?.accountName) {
    return null;
  }

  return (
    <div
      className="rounded-md border px-3 py-2"
      data-testid="account-switcher"
      title={t('accountSwitcher.switchingUnavailable')}
    >
      <p className="text-[0.625rem] tracking-wide text-[var(--color-muted-foreground)] uppercase">
        {t('common.account')}
      </p>
      <p className="truncate text-sm font-medium">{me.accountName}</p>
    </div>
  );
}
